import { createReducer, on } from '@ngrx/store';
import ModuleActions from '../../actions/generations/module.actions';
import { GenerationActions } from '../../actions/generations/generation.actions';

interface ModuleState {
  modules: any[];
}

const initialState: ModuleState = {
  modules: []
};

const moduleReducer = createReducer(
  initialState,
  on(ModuleActions.setModules, (state, { data }) => {
    return {
      ...state,
      modules: [...data]
    };
  }),
  on(ModuleActions.saveModule, (state, { data }) => {
    let isPartialUpdateHappened = false;
    let updatedModules = state.modules.map((m: any) => {
      if (m.sid === data.sid) {
        m = { ...m, ...data };
        isPartialUpdateHappened = true;
      }
      return m;
    });

    if (!isPartialUpdateHappened) {
      updatedModules = [data, ...updatedModules];
    }

    return {
      ...state,
      modules: updatedModules
    };
  }),
  on(ModuleActions.deleteModuleSuccess, (state, { componentId }) => {
    const updatedModules = state.modules.filter((m: any) => m.sid !== componentId);
    return {
      ...state,
      modules: updatedModules
    };
  }),
  on(ModuleActions.clearModules, (state) => {
    return {
      ...state,
      modules: []
    };
  }),
  on(GenerationActions.resetGeneration, (state) => ({
    ...initialState
  }))
);

export { moduleReducer, ModuleState };
